module.exports = __webpack_public_path__ + "static/img/returnScore_topBackground_jinri_credit.08a07486.png";